export class RoutingConstants {
  public static readonly HomeRoute = '/';
  public static readonly RoleLibrary = '/rolelibrary';
  public static readonly CareerPlan = '/careerplan';
  public static readonly CompareRoute = '/compare';
  public static readonly AboutRoute = '/about';
  public static readonly OpportuntiesRoute = '/careerplan/opportunties';
}

/**
 * break points:
 *
 * 1932px and up : xxxl
 *
 * 1366-1919 : xxl
 *
 * 1024-1365 : xl
 *
 * 640-1023 : l
 *
 * 480-639 : m
 *
 * 320-479 : s
 */
export enum BreakPoints {
  xxl = '@media (max-width: 1919px)',
  xl = '@media (max-width: 1365px)',
  l = '@media (max-width: 1023px)',
  m = '@media (max-width: 639px)',
  s = '@media (max-width: 479px)',
}

export enum BreakPointsMin {
  xxl = '@media (min-width: 1919px)',
  xl = '@media (min-width: 1365px)',
  l = '@media (min-width: 1023px)',
  m = '@media (min-width: 639px)',
  s = '@media (min-width: 479px)',
}

export const filterConstants = {
  all: 'All skills',
  required: 'Required Upon Hire and Critical/Important',
  notRequired: 'NOT Required Upon Hire and Critical/Important',
};
